import { createContext } from '@jd/jmtd/es/tools/context';
export var FormGroupContext = createContext();